import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-03f99464"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "StallItem"
}
const _hoisted_2 = {
  key: 0,
  class: "crown"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"margin-right":"5px"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/market/market_crown_icon.svg",
  alt: ""
}, null, -1))
const _hoisted_4 = { class: "flex-bwn mt-10" }
const _hoisted_5 = { class: "stallTitle" }
const _hoisted_6 = { class: "titleName" }
const _hoisted_7 = { class: "subTitle" }
const _hoisted_8 = { class: "nowrap" }
const _hoisted_9 = { class: "merito" }
const _hoisted_10 = { class: "shops flex" }
const _hoisted_11 = { class: "imgBox" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  style: {"width":"100%"},
  src: "https://static-s.theckb.com/BusinessMarket/Client/shop_img_back.png",
  alt: ""
}, null, -1))
const _hoisted_13 = { class: "cn-price" }
const _hoisted_14 = { class: "other-price" }

import { suppliersSearch } from '@/apis/goods'
import { useRequest } from '@/util/useLoading'
import { calc, formatMoneyDirection } from '@/util/useYan'
import { ArrowRightBold } from '@element-plus/icons-vue'
import { onMounted, ref } from 'vue'
import { t } from '@/plugins/i18n'
import { isKO, useRtfix, useSite2Station } from '@/store'
import { ElMessage } from 'element-plus'
import { Site } from '@/common/const'
import SvgIcon from '@/components/icons/SvgIcon.vue'

export default /*#__PURE__*/_defineComponent({
  props: ['stall'],
  setup(__props) {

const props = __props


// 商品列表
const shopList = ref<any>(undefined)
const [loading, api] = useRequest(suppliersSearch)
const supplierRes = ref()
const stationCode = useSite2Station()
onMounted(async () => {
  const res: any = await api({ shopCode: props?.stall?.supplierShopCode, pageNum: 1, pageSize: 3, sortType: 'update_time', descendOrder: true, footprint: false })
  shopList.value = res?.data?.productPage?.records ?? []
  const result = (res.data?.supplierRespDTO ?? {})
  const shopMajorCateName = {
    [Site.JA]: result.shopMajorCateNameJp,
    [Site.KO]: result!.shopMajorCateNameKr,
    [Site.EN]: result!.shopMajorCateNameEn
  }[stationCode] as string
  supplierRes.value = {
    ...result,
    shopMajorCateName
  }
})

const checkBlack = (e: any) => {
  if (props?.stall?.shopIsBlack === 1) {
    ElMessage.warning(t('该供应商因次品过多，无法购买其产品'))
    e.preventDefault()
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_skeleton_item = _resolveComponent("el-skeleton-item")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_skeleton = _resolveComponent("el-skeleton")!

  return (shopList.value === undefined || shopList.value?.length === 3)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (__props.stall.strongSupplier === 1)
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_unref(t)('实力档口')), 1)
            ]))
          : _createCommentVNode("", true),
        _createVNode(_component_el_skeleton, {
          style: {"width":"100%"},
          loading: _unref(loading),
          animated: ""
        }, {
          template: _withCtx(() => [
            _createVNode(_component_el_skeleton_item, {
              variant: "text",
              style: {"height":"28px"}
            }),
            _createVNode(_component_el_skeleton_item, {
              variant: "text",
              style: {"width":"50%","height":"22px","margin-top":"4px","margin-bottom":"8px"}
            }),
            _createElementVNode("div", _hoisted_4, [
              (_openBlock(), _createElementBlock(_Fragment, null, _renderList([1, 2, 3], (item, index) => {
                return _createElementVNode("div", {
                  class: "flex-1 flex-col",
                  key: index
                }, [
                  _createVNode(_component_el_skeleton_item, {
                    variant: "image",
                    style: {"width":"105px","height":"107px","border-radius":"6px"}
                  }),
                  _createVNode(_component_el_skeleton_item, {
                    variant: "text",
                    style: {"height":"24px","margin-top":"8px"}
                  })
                ])
              }), 64))
            ])
          ]),
          default: _withCtx(() => [
            _createVNode(_component_router_link, {
              target: "_blank",
              to: _unref(useRtfix)('list', { query: { shopCode: __props.stall?.supplierShopCode } }),
              onClickCapture: checkBlack
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, _toDisplayString(supplierRes.value?.shopName), 1),
                  _createVNode(_component_el_icon, null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(ArrowRightBold), { class: "arrow" })
                    ]),
                    _: 1
                  })
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(t)('主营类目')) + "：", 1),
                  _createElementVNode("div", _hoisted_9, _toDisplayString(supplierRes.value?.shopMajorCateName), 1)
                ]),
                _createElementVNode("div", _hoisted_10, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shopList.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "shop-item",
                      key: index
                    }, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_el_image, {
                          class: "img",
                          referrerpolicy: "no-referrer",
                          src: item?.productMainImg,
                          alt: ""
                        }, {
                          error: _withCtx(() => [
                            _hoisted_12
                          ]),
                          _: 2
                        }, 1032, ["src"])
                      ]),
                      _createElementVNode("div", {
                        class: "goods-item-price line--only",
                        style: _normalizeStyle(`color: ${_unref(isKO)() ? '#333333' : 'red'};`)
                      }, [
                        _createElementVNode("span", _hoisted_13, _toDisplayString(`${item?.productSellPrice}${_unref(t)("元")}`), 1),
                        _createElementVNode("span", _hoisted_14, _toDisplayString(`（${_unref(formatMoneyDirection)(_unref(calc)(item?.productSellPrice))}）`), 1)
                      ], 4)
                    ]))
                  }), 128))
                ])
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _: 1
        }, 8, ["loading"])
      ]))
    : _createCommentVNode("", true)
}
}

})